import { API_PATH } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { IChangePasswordRepository } from "features/changePassword/domain/repositories/IChangePasswordRepository";
import { injectable } from "tsyringe";
import { ChangePasswordRequestModel } from "./model/ChangePasswordRequestModel";

@injectable()
export class ChangePasswordImpl implements IChangePasswordRepository {
  async changePassword(
    body: ChangePasswordRequestModel,
  ): Promise<BaseApiResponseModel<any>> {
    return await client?.patch(API_PATH.CHANGE_PASS, body);
  }
}
